import * as icons from './technologies';

export const skillsT = [
    {
        icon: icons.html5,
        name: 'HTML',
        color: '#F24130'
    },
    {
        icon: icons.css3,
        name: 'CSS',
        color: '#18A2D9'
    },
    {
        icon: icons.javascript,
        name: 'javaScript',
        color: '#F2D852'
    },
    {
        icon: icons.react,
        name: 'React',
        color: '#5ED7F2'
    },
    {
        icon: icons.typescript,
        name: 'TypeScript',
        color: '#1B72BF'
    },
    {
        icon: icons.tailwindcss,
        name: 'Tailwind',
        color: '#66C4D9'
    },
    {
        icon: icons.bootstrap,
        name: 'Bootstrap',
        color: '#7013F2'
    },
    {
        icon: icons.sass,
        name: 'SASS',
        color: '#D96CA8'
    }, 
    {
        icon: icons.nodejs,
        name: 'Node',
        color: '#539E43'
    }, 
    {
        icon: icons.nextjs,
        name: 'NextJS',
        color: '#f2f2f2'
    }, 
]